import React, { ReactElement, useCallback } from "react";
import { useDocumentUpload } from "@src/components/modules/Upload/useDocumentUpload";
import { Upload } from "@src/components/modules";
import { UploadDocumentType } from "@src/components/modules/Upload/UploadDocumentType";
import { CreateDocumentMutation } from "@src/__generated__/graphql";

interface Props {
  className?: string;
  onDocsUploaded?: (docs: CreateDocumentMutation["createDocument"][]) => void;
  serviceIds?: string[];
  children?: ReactElement;
}
export const allowedDocTypes = [
  UploadDocumentType.PDF,
  UploadDocumentType.DOCX,
  UploadDocumentType.DOC,
  UploadDocumentType.PPTX,
  UploadDocumentType.XLSX,
  UploadDocumentType.JPG,
  UploadDocumentType.JPEG,
  UploadDocumentType.PNG,
];

export const UploadDocuments: React.FC<Props> = ({
  className,
  children,
  onDocsUploaded,
  serviceIds,
}) => {
  const { addFiles, loading } = useDocumentUpload();

  const onDocsAdded = useCallback(
    async (docs: File[]) => {
      const uploadedDocs = await addFiles({ files: docs, serviceIds });
      onDocsUploaded &&
        onDocsUploaded(uploadedDocs.map((doc) => doc.createDocument));
    },
    [onDocsUploaded, serviceIds, addFiles],
  );

  return (
    <Upload
      onDocsAdded={onDocsAdded}
      className={className}
      loading={loading}
      allowedTypes={allowedDocTypes}
    >
      {children}
    </Upload>
  );
};
